import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPlusCircle } from 'react-icons/fa';
import styles from './BoardMember.module.css';

const BoardMember = () => {
  // Use state to track which member's info is visible
  const [activeMemberId, setActiveMemberId] = useState(null);

  const toggleInfo = (id) => {
    setActiveMemberId(activeMemberId === id ? null : id);
  };

  const members = [
    {
      id: 1,
      name: "Mir Yousuf",
      role: "Founder",
      img: "/images/board/founder.jpeg",
      info: "Mir Yousuf, Founder of Z Foundation, is a visionary leader driven by compassion and a strong sense of social responsibility. His leadership transforms empathy into impactful initiatives."
    },
    {
      id: 6,
      name: "Afreen Fathima",
      role: "Co-Founder",
      img: "/images/board/Afreen Fathima.jpeg",
      info: "Afreen Fathima, Co-Founder of Z Foundation, is dedicated to implementing the foundation's vision and ensuring every program reaches its maximum potential for community upliftment."
    },
    {
      id: 2,
      name: "Sanjay S",
      role: "Ceo",
      img: "/images/board/img5.jpeg",
      info: "Sanjay is a young leader driven by purpose, dedicating his skills and energy to uplift those in need through strategic planning."
    },
    {
      id: 3,
      name: "Praveen A",
      role: "General Secretary",
      img: "/images/board/img3.jpeg",
      info: "Praveen manages foundation operations with a focus on community empowerment and grassroots mobilization."
    },
    {
      id: 4,
      name: "Madhu SD",
      role: "Joint Secretary",
      img: "/images/board/img2.jpeg",
      info: "Madhu oversees healthcare and nutrition programs, ensuring effective implementation for the underserved communities."
    },
    {
      id: 5,
      name: "Praveena R",
      role: "Treasurer",
      img: "/images/board/img4.jpeg",
      info: "Praveena manages financial integrity, ensuring every donation reaches its intended cause with complete transparency."
    }
  ];

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1 }}
      className={styles.boardSection}
    >
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className={styles.redHeading}
      >
        Our Board of Directors
      </motion.h2>

      {/* 1. Leadership Row (Founder & CEO) */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className={styles.leadershipWrapper}
      >
        <MemberCard
          member={members[0]}
          isOpen={activeMemberId === members[0].id}
          onToggle={() => toggleInfo(members[0].id)}
        />
        <MemberCard
          member={members[1]}
          isOpen={activeMemberId === members[1].id}
          onToggle={() => toggleInfo(members[1].id)}
        />
      </motion.div>

      {/* 2. Executive Member Grid */}
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          hidden: { opacity: 0 },
          show: {
            opacity: 1,
            transition: {
              staggerChildren: 0.15
            }
          }
        }}
        className={styles.memberGrid}
      >
        {members.slice(2).map((member) => (
          <motion.div
            key={member.id}
            variants={{
              hidden: { opacity: 0, y: 30 },
              show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
            }}
          >
            <MemberCard
              member={member}
              isOpen={activeMemberId === member.id}
              onToggle={() => toggleInfo(member.id)}
            />
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

// Reusable card component to ensure same-to-same look
const MemberCard = ({ member, isOpen, onToggle }) => (
  <div className={styles.memberCard}>
    <div className={styles.imgWrapper}>
      <img src={member.img} alt={member.name} className={styles.avatarImg} />
    </div>
    <h4 className={styles.memberName}>{member.name}</h4>
    <p className={styles.memberRole}>{member.role}</p>

    <div className={styles.plusBox} onClick={onToggle}>
      <FaPlusCircle
        className={styles.greenIcon}
        style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
      />
    </div>

    {isOpen && (
      <div className={styles.detailsBox}>
        <p className={styles.detailsText}>{member.info}</p>
      </div>
    )}
  </div>
);

export default BoardMember;